import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/app/App';
import '@/styles/variables.css';
import '@/styles/global.css';
import '@/styles/animations.module.css';
import { initAnalytics } from '@/utils/analytics';

initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
